import { createRootRoute, Navigate, Outlet } from "@tanstack/react-router";
import "../index.css";
import { Toaster } from "@/components/ui/sonner";
import { Auth } from "@/lib/auth";
import { useVersionCheck } from "@/lib/version-check";

function RootComponent() {
  useVersionCheck();
  return (
    <>
      <Toaster />
      <Auth.AuthProvider>
        <Outlet />
      </Auth.AuthProvider>
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <Navigate to="/login" />,
});
